export const AddCircleIcon = ({
  strokeColor = "var(--color-txt-paragraph)",
  ...props
}: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M7.9987 1.33203C4.32536 1.33203 1.33203 4.32536 1.33203 7.9987C1.33203 11.672 4.32536 14.6654 7.9987 14.6654C11.672 14.6654 14.6654 11.672 14.6654 7.9987C14.6654 4.32536 11.672 1.33203 7.9987 1.33203ZM10.6654 8.4987H8.4987V10.6654C8.4987 10.9387 8.27203 11.1654 7.9987 11.1654C7.72536 11.1654 7.4987 10.9387 7.4987 10.6654V8.4987H5.33203C5.0587 8.4987 4.83203 8.27203 4.83203 7.9987C4.83203 7.72536 5.0587 7.4987 5.33203 7.4987H7.4987V5.33203C7.4987 5.0587 7.72536 4.83203 7.9987 4.83203C8.27203 4.83203 8.4987 5.0587 8.4987 5.33203V7.4987H10.6654C10.9387 7.4987 11.1654 7.72536 11.1654 7.9987C11.1654 8.27203 10.9387 8.4987 10.6654 8.4987Z"
      fill={strokeColor}
    />
  </svg>
);
